import type { I18nMessages } from "@/shared/i18n/types";

export const enUSMessages: I18nMessages = {
  "agents.page.count": "{count} available agents",
  "agents.page.title": "Agents",
  "agentConsole.action.add": "Add",
  "agentConsole.action.cancelEdit": "Cancel edit",
  "agentConsole.action.confirmDelete": "Confirm delete",
  "agentConsole.action.create": "Create agent",
  "agentConsole.action.delete": "Delete",
  "agentConsole.action.new": "New",
  "agentConsole.action.refresh": "Refresh agents",
  "agentConsole.action.retry": "Retry",
  "agentConsole.action.saveChanges": "Save changes",
  "agentConsole.detail.createSubtitle": "Saved changes are written to the backend agent config",
  "agentConsole.detail.titleCreate": "New agent",
  "agentConsole.detail.titleEdit": "Edit agent",
  "agentConsole.diagnostics.title": "Diagnostics",
  "agentConsole.diagnostics.uneditable": "This config cannot be parsed, so structured saving is disabled until the source file is fixed.",
  "agentConsole.empty": "No matching agents.",
  "agentConsole.error.jsonArray": "{label} must be a JSON array.",
  "agentConsole.error.jsonInvalid": "{label} JSON is invalid: {detail}",
  "agentConsole.error.jsonObject": "{label} must be a JSON object.",
  "agentConsole.error.keyRequired": "Enter an Agent Key.",
  "agentConsole.error.nameRequired": "Enter a name.",
  "agentConsole.error.structuredSaveUnavailable": "This agent config cannot be saved with the structured editor until the source file is fixed.",
  "agentConsole.field.description": "Description",
  "agentConsole.field.mode": "Mode",
  "agentConsole.field.name": "Name",
  "agentConsole.field.role": "Role",
  "agentConsole.list.count": "Agents {count}",
  "agentConsole.list.dragHandle": "Drag to reorder {name}",
  "agentConsole.list.savingOrder": "Saving order...",
  "agentConsole.list.toolsSkills": "Tools {tools} · Skills {skills}",
  "agentConsole.placeholder.iconImage": "/assets/agent.svg or https://...",
  "agentConsole.searchPlaceholder": "Search agents...",
  "agentConsole.section.advancedConfig": "Advanced config",
  "agentConsole.section.capabilities": "Capabilities",
  "agentConsole.status.invalid": "Invalid",
  "agentConsole.wonders.remove": "Remove recommended prompt",
  "automationConsole.action.cancelEdit": "Cancel edit",
  "automationConsole.action.confirmDelete": "Confirm delete",
  "automationConsole.action.create": "Create automation",
  "automationConsole.action.delete": "Delete",
  "automationConsole.action.disable": "Disable",
  "automationConsole.action.enable": "Enable",
  "automationConsole.action.new": "New",
  "automationConsole.action.refresh": "Refresh",
  "automationConsole.action.retry": "Retry",
  "automationConsole.action.saveChanges": "Save changes",
  "automationConsole.cronPreset.ariaLabel": "Cron quick presets",
  "automationConsole.cronPreset.dailyNine": "Every day 09:00",
  "automationConsole.cronPreset.everyFiveMinutes": "Every 5 minutes",
  "automationConsole.cronPreset.hourly": "Hourly",
  "automationConsole.cronPreset.placeholder": "Quick presets",
  "automationConsole.cronPreset.weekdaySix": "Weekdays 18:00",
  "automationConsole.detail.createSubtitle": "Saved changes are written to the backend automation config immediately",
  "automationConsole.detail.titleCreate": "New automation",
  "automationConsole.detail.titleEdit": "Edit automation",
  "automationConsole.empty": "No matching automations.",
  "automationConsole.error.agentRequired": "Enter an AgentKey.",
  "automationConsole.error.cronFormat": "Cron must use the traditional 5-field format.",
  "automationConsole.error.cronRequired": "Enter a cron expression.",
  "automationConsole.error.descriptionRequired": "Enter an automation description.",
  "automationConsole.error.messageRequired": "Enter an automation message.",
  "automationConsole.error.nameRequired": "Enter an automation name.",
  "automationConsole.error.paramsJsonInvalid": "Params JSON is invalid: {detail}",
  "automationConsole.error.paramsObject": "Params must be a JSON object.",
  "automationConsole.error.remainingRunsPositive": "Remaining runs must be a positive integer.",
  "automationConsole.executions.empty": "No execution records.",
  "automationConsole.executions.emptyNoSelection": "Save or select an automation to view execution records.",
  "automationConsole.executions.title": "Execution records",
  "automationConsole.field.agent": "Agent",
  "automationConsole.field.agentPlaceholder": "Select an agent",
  "automationConsole.field.chatId": "Chat ID",
  "automationConsole.field.defaultTimezone": "Default timezone",
  "automationConsole.field.description": "Description",
  "automationConsole.field.enabled": "Enable automation",
  "automationConsole.field.hidden": "Hidden",
  "automationConsole.field.message": "Automation message",
  "automationConsole.field.name": "Name",
  "automationConsole.field.params": "Params",
  "automationConsole.field.paramsTooltip": "JSON format",
  "automationConsole.field.remainingRuns": "Remaining runs",
  "automationConsole.field.remainingRunsPlaceholder": "Leave blank for unlimited runs",
  "automationConsole.field.role": "Role",
  "automationConsole.field.timezone": "Timezone",
  "automationConsole.filter.status.all": "All statuses",
  "automationConsole.filter.status.disabled": "Disabled",
  "automationConsole.filter.status.enabled": "Enabled",
  "automationConsole.filter.worker.all": "All targets",
  "automationConsole.hidden.false": "No",
  "automationConsole.hidden.true": "Yes",
  "automationConsole.hidden.unset": "Unset",
  "automationConsole.list.count": "Automations {count}",
  "automationConsole.list.lastStatus": "Last {status}",
  "automationConsole.list.nextFire": "Next {time}",
  "automationConsole.searchPlaceholder": "Search automations...",
  "automationConsole.section.request": "Request",
  "automationConsole.status.disabled": "Disabled",
  "automationConsole.status.enabled": "Enabled",
  "automationConsole.worker.agent": "Agent · {id}",
  "automationConsole.worker.team": "Team · {id}",
  "registryConsole.action.create": "Create config",
  "registryConsole.action.new": "New",
  "registryConsole.action.refresh": "Refresh",
  "registryConsole.action.refreshFile": "Refresh file",
  "registryConsole.action.retry": "Retry",
  "registryConsole.action.save": "Save",
  "registryConsole.action.validate": "Validate",
  "registryConsole.capability.function": "Function",
  "registryConsole.capability.reasoner": "Reasoner",
  "registryConsole.capability.vision": "Vision",
  "registryConsole.category.models": "Models",
  "registryConsole.category.mcp-servers": "MCP Servers",
  "registryConsole.category.providers": "Providers",
  "registryConsole.category.viewport-servers": "Viewport Servers",
  "registryConsole.category.tools": "Tools",
  "registryConsole.confirm.discard": "This YAML has unsaved changes. Discard them?",
  "registryConsole.detail.empty": "Select or create a registry config.",
  "registryConsole.detail.titleCreate": "New registry config",
  "registryConsole.editor.label": "YAML config",
  "registryConsole.empty": "No matching registry configs.",
  "registryConsole.field.category": "Category",
  "registryConsole.field.file": "File",
  "registryConsole.field.size": "Size",
  "registryConsole.field.updatedAt": "Updated",
  "registryConsole.filter.category.all": "All categories",
  "registryConsole.filter.status.all": "All statuses",
  "registryConsole.filter.status.disabled": "Disabled",
  "registryConsole.filter.status.invalid": "Invalid",
  "registryConsole.filter.status.ready": "Ready",
  "registryConsole.list.count": "Configs {count}",
  "registryConsole.message.catalogUpdated": "Config updated",
  "registryConsole.message.newDraft": "Draft created",
  "registryConsole.message.savedWaiting": "Saved. The watcher will apply it automatically; refresh to view updates",
  "registryConsole.message.unsaved": "Unsaved",
  "registryConsole.message.validationInvalid": "Validation found errors",
  "registryConsole.message.validationReady": "Validation passed",
  "registryConsole.meta.toolsCount": "Tools {count}",
  "registryConsole.mcpTools.empty.missingServerKey": "Tool summaries do not provide serverKey, so they cannot be attributed yet",
  "registryConsole.mcpTools.empty.noTools": "No tools are attributed to this MCP server",
  "registryConsole.mcpTools.section.title": "Tools {count}",
  "registryConsole.searchPlaceholder": "Search registry configs...",
  "registryConsole.section.categories": "Registry categories",
  "registryConsole.section.diagnostics": "Diagnostics",
  "registryConsole.section.summary": "Summary",
  "registryConsole.status.disabled": "Disabled",
  "registryConsole.status.invalid": "Invalid",
  "registryConsole.status.ready": "Ready",
  "registryConsole.searchToolsPlaceholder": "Search tools by name, key, description...",
  "registryConsole.tools.empty": "No registered tools",
  "registryConsole.tools.detail.empty": "Select a tool to view details",
  "registryConsole.tools.field.name": "Name",
  "registryConsole.tools.field.key": "Key",
  "registryConsole.tools.field.kind": "Kind",
  "registryConsole.tools.field.source": "Source",
  "registryConsole.tools.field.sourceType": "Source type",
  "registryConsole.tools.field.sourceCategory": "Source category",
  "registryConsole.tools.field.serverKey": "MCP",
  "registryConsole.tools.field.description": "Description",
  "registryConsole.list.count.tools": "Tools {count}",
  "toolSource.platform": "Platform",
  "toolSource.external": "External",
  "toolSource.mcp": "MCP",
  "api.downloadFailedWithStatus": "Download failed ({status})",
  "api.fileDownloadUnsupported": "File download is not supported in this environment",
  "api.loadResourceTextFailedWithStatus": "Failed to load resource text ({status})",
  "composer.actions.interrupt": "Interrupt run",
  "composer.actions.plan": "Plan",
  "composer.actions.screenshot": "Screenshot",
  "composer.actions.screenshotCapturing": "Capturing screenshot...",
  "composer.actions.screenshotDisabled.frontendActive": "A frontend tool is active. Screenshots are temporarily unavailable.",
  "composer.actions.screenshotDisabled.streaming": "A run is active. Appending screenshots is not supported right now.",
  "composer.actions.screenshotDisabled.voiceMode": "Switch back to text input before capturing a screenshot.",
  "composer.actions.screenshotFailed": "Screenshot capture failed",
  "composer.actions.screenshotTimeout": "Screenshot timed out. Try again.",
  "composer.actions.screenshotUnavailable": "Screenshot unavailable",
  "composer.actions.send": "Send",
  "composer.actions.stopVoiceInput": "Stop voice input",
  "composer.actions.upload": "Upload files",
  "composer.actions.uploadDisabled.frontendActive": "A frontend tool is active. File uploads are temporarily unavailable.",
  "composer.actions.uploadDisabled.streaming": "A run is active. Appending files is not supported right now.",
  "composer.actions.uploadDisabled.voiceMode": "Switch back to text input before uploading files.",
  "composer.actions.voiceInput": "Voice input",
  "composer.actions.voiceInputDisabled.frontendActive": "A frontend tool is active. Voice input is temporarily unavailable.",
  "composer.actions.voiceUnavailable": "Voice input unavailable",
  "composer.accessLevel.failed": "Access level update failed",
  "composer.accessLevel.failedWithDetail": "Access level update failed: {detail}",
  "composer.accessLevel.rejected": "The current run did not accept the access change. Reverted to the previous value.",
  "composer.accessLevel.rejectedWithDetail": "The current run did not accept the access change ({detail}). Reverted to the previous value.",
  "composer.attachments.removeFile": "Remove file {name}",
  "composer.attachments.viewLeft": "View attachments on the left",
  "composer.attachments.viewRight": "View attachments on the right",
  "composer.awaiting.alreadyResolved": "This awaiting item was already submitted from another client.",
  "composer.awaiting.expired": "This action expired or is no longer valid, and the UI has been restored automatically.",
  "composer.awaiting.unmatched": "Awaiting submission did not match: {detail}",
  "confirmDialog.loading": "Generating questions...",
  "confirmDialog.validation.date": "Choose a valid date in {format} format.",
  "confirmDialog.validation.multiSelect": "Choose at least one option.",
  "confirmDialog.validation.number": "Enter a number.",
  "confirmDialog.validation.select": "Choose one option.",
  "confirmDialog.validation.text": "Enter content.",
  "composer.background.learn.error": "Learning failed",
  "composer.background.learn.pending": "Learning...",
  "composer.background.compact.error": "Context compaction failed",
  "composer.background.compact.pending": "Compacting context...",
  "composer.background.remember.error": "Memory save failed",
  "composer.background.remember.pending": "Saving memory...",
  "composer.input.placeholder.default": "Reply... (Enter to send, Shift+Enter for a new line)",
  "composer.input.placeholder.expanded": "Enter inserts a new line. Esc collapses the input.",
  "composer.input.placeholder.frontendActive": "A frontend tool is active. Submit from the confirmation panel.",
  "composer.input.tooltip.collapse": "Collapse input. Enter sends.",
  "composer.input.tooltip.expand": "Expand input. Enter creates a new line.",
  "composer.query.access.auto_approve": "Auto approve",
  "composer.query.access.default": "Default access",
  "composer.query.access.full_access": "Full access",
  "composer.query.access.title": "Set access for this run",
  "composer.query.model.default": "Default model",
  "composer.query.model.empty": "No models available",
  "composer.query.model.group": "Model",
  "composer.query.model.loadFailed": "Failed to load models. Reopen to retry",
  "composer.query.model.loading": "Loading models...",
  "composer.query.model.saving": "Saving...",
  "composer.query.model.title": "Choose model and reasoning effort",
  "composer.query.reasoning.HIGH": "High",
  "composer.query.reasoning.LOW": "Low",
  "composer.query.reasoning.MAX": "Max",
  "composer.query.reasoning.MEDIUM": "Medium",
  "composer.query.reasoning.NONE": "Off",
  "composer.query.reasoning.XHIGH": "Extra high",
  "composer.query.reasoning.default": "Default reasoning",
  "composer.query.reasoning.empty": "No reasoning efforts available",
  "composer.query.reasoning.group": "Reasoning effort",
  "composer.query.serviceTier.FAST": "Fast",
  "composer.query.serviceTier.FLEX": "Flex",
  "composer.query.serviceTier.STANDARD": "Standard",
  "composer.query.serviceTier.group": "Speed mode",
  "composer.speech.error": "Speech recognition error: {detail}",
  "composer.speech.listening": "Listening...",
  "composer.speech.ready": "Click to start dictation",
  "composer.speech.retry": "Speech recognition did not start. Please try again.",
  "composer.speech.unsupported": "Voice input is not supported in this browser",
  "composer.steer.cancel": "Cancel",
  "composer.steer.failed": "Steer failed: {detail}",
  "composer.steer.rejected": "The current run did not accept steering ({detail}). Your text was restored to the input.",
  "composer.steer.submit": "Steer",
  "composer.steer.unavailable": "The current run is no longer steerable. Your text was restored to the input.",
  "composer.tooltip.createPlan": "Create plan",
  "composer.tooltip.planShortcut": "to toggle",
  "composer.voice.assistantLabel": "Assistant reply",
  "composer.voice.assistantPlaceholder": "Waiting for a reply...",
  "composer.voice.assistantThinkingPlaceholder": "Drafting a reply...",
  "composer.voice.currentWorker": "Current agent: ",
  "composer.voice.status.connecting": "Connecting voice chat...",
  "composer.voice.status.error": "Voice chat connection error",
  "composer.voice.status.listening": "Listening to you",
  "composer.voice.status.ready": "Switch to voice mode",
  "composer.voice.status.speaking": "Speaking the reply",
  "composer.voice.status.thinking": "Thinking about the reply",
  "composer.voice.title": "Voice chat",
  "composer.voice.userLabel": "You just said",
  "composer.voice.userPlaceholder": "Waiting for you to speak...",
  "composer.wonders.ariaLabel": "Recommended prompts",
  "composer.wonders.itemLabel": "Prompt {index}",
  "composer.wonders.kicker": "Ideas",
  "composer.wonders.title": "Try one of these prompts",
  "composer.wonders.shuffle": "Refresh",
  "composer.wonders.shuffleAriaLabel": "Shuffle recommended prompts",
  "copilot.panel.close": "Close panel",
  "copilot.panel.debug": "Debug",
  "copilot.panel.overview": "Overview",
  "copilot.panel.preview": "Preview",
  "copilot.panel.sourceDetail": "Source",
  "copilot.panel.planningPreview": "Planning",
  "rightSidebar.debug.empty": "No events",
  "rightSidebar.debug.openChat.agent": "Agent",
  "rightSidebar.debug.openChat.agentTitle": "Open Agent chat in a new page",
  "rightSidebar.debug.openChat.copilot": "Copilot",
  "rightSidebar.debug.openChat.copilotTitle": "Open Copilot chat in a new page",
  "rightSidebar.debug.tabs.action": "action",
  "rightSidebar.debug.tabs.all": "All",
  "rightSidebar.debug.tabs.artifact": "artifact",
  "rightSidebar.debug.tabs.awaiting": "awaiting",
  "rightSidebar.debug.tabs.chat": "chat",
  "rightSidebar.debug.tabs.content": "content",
  "rightSidebar.debug.tabs.debug": "debug",
  "rightSidebar.debug.tabs.labelWithCount": "{label} ({count})",
  "rightSidebar.debug.tabs.memory": "memory",
  "rightSidebar.debug.tabs.plan": "plan",
  "rightSidebar.debug.tabs.planning": "planning",
  "rightSidebar.debug.tabs.reasoning": "reasoning",
  "rightSidebar.debug.tabs.request": "request",
  "rightSidebar.debug.tabs.run": "run",
  "rightSidebar.debug.tabs.source": "source",
  "rightSidebar.debug.tabs.task": "task",
  "rightSidebar.debug.tabs.tool": "tool",
  "rightSidebar.overview.artifacts.empty": "No artifacts",
  "rightSidebar.overview.artifacts.title": "Artifacts",
  "rightSidebar.overview.fileChanges.empty": "No file changes",
  "rightSidebar.overview.fileChanges.emptyCoder": "No code changes",
  "rightSidebar.overview.fileChanges.diffEmpty": "No differences",
  "rightSidebar.overview.fileChanges.diffLoading": "Loading diff...",
  "rightSidebar.overview.fileChanges.diffUnavailable": "Diff unavailable",
  "rightSidebar.overview.fileChanges.title": "File changes",
  "rightSidebar.overview.fileChanges.titleCoder": "Code changes",
  "rightSidebar.overview.planning.title": "Plan",
  "rightSidebar.overview.planning.empty": "No plan",
  "rightSidebar.overview.tasks.title": "Tasks",
  "rightSidebar.overview.tasks.empty": "No tasks",
  "rightSidebar.preview.actions.close": "Close",
  "rightSidebar.preview.error.audio": "Audio preview failed. Download the file to view it.",
  "rightSidebar.preview.error.download": "Attachment download failed",
  "rightSidebar.preview.error.image": "Image preview failed. Download the file to view it.",
  "rightSidebar.preview.error.loadText": "Preview failed to load",
  "rightSidebar.preview.error.video": "Video preview failed. Download the file to view it.",
  "rightSidebar.preview.note": "Actual preview rendering for some files depends on the browser and backend response headers. The text file only displays 5MB of content. To view the complete file, please simply download it.",
  "rightSidebar.preview.office.downloadOnly": "Office documents cannot be previewed here. Download the file to view it.",
  "rightSidebar.preview.text.empty": "The file is empty",
  "rightSidebar.preview.text.loading": "Loading text preview...",
  "rightSidebar.sourceDetail.chunkCount": "{count} chunks",
  "rightSidebar.sourceDetail.chunkLabel": "Chunk #{index}",
  "rightSidebar.sourceDetail.empty": "No source data",
  "rightSidebar.sourceDetail.selectChunk": "Select a chunk to view details",
  "rightSidebar.sourceDetail.untitledChunk": "Untitled chunk",
  "rightSidebar.planningPreview.empty": "No planning node data",
  "rightSidebar.resize.ariaLabel": "Resize right sidebar",
  "rightSidebar.resize.title": "Drag to resize the right sidebar",
  "approvalDialog.action.continue": "Continue",
  "approvalDialog.action.skip": "Skip",
  "approvalDialog.action.submit": "Submit",
  "confirmDialog.action.skip": "Skip",
  "approvalDialog.loading": "Loading approval request...",
  "approvalDialog.remoteAnswered": "This request was already submitted from another client.",
  "approvalDialog.option.approve": "Approve",
  "approvalDialog.option.approve.description": "Allow this request once",
  "approvalDialog.option.approveRuleRun": "Approve matching requests for this run",
  "approvalDialog.option.approveRuleRun.description": "Automatically allow matching requests in this run",
  "approvalDialog.option.reject": "Reject",
  "approvalDialog.rejectDefaultReason": "Reject this approval request",
  "approvalDialog.rejectPlaceholder": "Tell me how to adjust it",
  "approvalDialog.selected": "Selected",
  "approvalDialog.status.autoSubmitting": "Auto-submitting...",
  "approvalDialog.timeoutResolved": "Awaiting timed out.",
  "approvalDialog.timeout.countdown": "Submit countdown {label}",
  "planDialog.option.approve": "Yes, implement this plan",
  "planDialog.option.reject": "No",
  "planDialog.rejectPlaceholder": "Tell me how to adjust it",
  "planDialog.skipReason": "Skip this plan implementation",
  "planDialog.titleFallback": "Implement this plan?",
  "awaiting.action.approve": "Approve",
  "awaiting.action.reject": "Reject",
  "awaiting.action.submit": "Submit",
  "awaiting.hint.rejectEditable": "Enter a reject reason. You can still edit the form contents.",
  "awaiting.hint.submitEditable": "Edit the form contents and submit.",
  "awaiting.load.failedWithDetail": "Failed to load the business confirmation form: {detail}",
  "awaiting.load.loading": "Loading form...",
  "awaiting.load.waiting": "Waiting for the business confirmation form...",
  "awaiting.remoteAnswered": "This request was already submitted from another client.",
  "awaiting.rejectReason.placeholder": "Enter a reject reason. You can still edit the form contents.",
  "awaiting.status.autoSubmitting": "Auto-submitting...",
  "awaiting.status.collecting": "Collecting...",
  "awaiting.status.submitting": "Submitting...",
  "awaiting.submit.failedWithDetail": "Submit failed: {detail}",
  "awaiting.submit.missingHandler": "Submit failed: missing submit handler",
  "awaiting.timeout.countdown": "Submit countdown {label}",
  "awaiting.timeoutResolved": "Awaiting timed out.",
  "awaiting.title": "Business confirmation",
  "archive.action.archive": "Archive",
  "archive.action.cancel": "Cancel",
  "archive.action.delete": "Delete",
  "archive.action.loadMore": "Load more",
  "archive.action.restore": "Restore",
  "archive.action.restoreAndOpen": "Restore and open",
  "archive.bulk.button": "Archive {count}",
  "archive.bulk.confirmContent": "Archive {count} conversations in the current filter that have not changed for more than {days} days.",
  "archive.bulk.confirmTitle": "Archive old conversations",
  "archive.bulk.days": "{days} days",
  "archive.bulk.dayUnit": "days",
  "archive.bulk.label": "Bulk archive older than",
  "archive.bulk.result": "Archived {success}.",
  "archive.bulk.resultWithFailures": "Archived {success}, failed {failed}.",
  "archive.deleteConfirm.title": "Delete archive record",
  "archive.detail.archivedAt": "Archived at {time}",
  "archive.empty.detail": "No previewable content in this archive.",
  "archive.empty.list": "No archived conversations.",
  "archive.empty.preview": "(no preview)",
  "archive.empty.select": "Select an archived conversation to view details.",
  "archive.filter.agentPlaceholder": "Filter by Agent Key...",
  "archive.list.ariaLabel": "Archived conversations",
  "archive.restore.failed": "Restore failed",
  "archive.restore.result": "Archived conversation restored.",
  "archive.restoreConfirm.title": "Restore archived conversation",
  "archive.search.placeholder": "Search archived titles or content...",
  "archive.item.agent": "Agent",
  "archive.item.created": "Created",
  "archive.item.lastRun": "Last run",
  "archive.item.updated": "Last run",
  "archive.tag.attachments": "Attachments",
  "archive.title": "Archive",
  "chatActions.archive.failed": "Archive failed",
  "chatActions.archive.menu": "Archive",
  "chatActions.archive.ok": "Archive",
  "chatActions.archive.title": "Archive conversation",
  "chatActions.cancel": "Cancel",
  "chatActions.delete.menu": "Delete",
  "chatActions.delete.ok": "Delete",
  "chatActions.delete.title": "Delete conversation",
  "chatActions.export": "Export",
  "chatActions.export.failed": "Export failed",
  "chatActions.export.success": "Exported to Downloads",
  "chatActions.rename.menu": "Rename",
  "chatActions.rename.ok": "Save",
  "chatActions.rename.placeholder": "Enter a new conversation name",
  "chatActions.rename.required": "Enter a conversation name",
  "chatActions.rename.title": "Rename conversation",
  "commandModal.detail.title": "Current details",
  "commandModal.history.title": "Conversation history",
  "commandModal.automation.title": "Automation",
  "commandModal.agents.title": "Agents",
  "commandModal.switch.title": "Switch {agentLabel}",
  "globalSearch.placeholder": "Search agents, chats, or run commands",
  "globalSearch.empty": "No results",
  "globalSearch.action.newConversation": "New Conversation",
  "globalSearch.action.history": "Chat History",
  "globalSearch.action.switch": "Switch {agentLabel}",
  "globalSearch.action.settings": "Settings",
  "globalSearch.action.debug": "Debug Panel",
  "globalSearch.group.awaiting": "Awaiting",
  "globalSearch.group.unread": "Unread chats",
  "globalSearch.group.actions": "Actions",
  "globalSearch.group.workers": "Agents",
  "globalSearch.group.history": "Conversations",
  "globalSearch.group.recommended": "Recommended",
  "globalSearch.group.agents": "Agents",
  "globalSearch.group.conversations": "Conversations",
  "globalSearch.row.unread": "Unread",
  "contextCompact.completed": "Context compacted",
  "contextCompact.compressionRatio": "Compression ratio: {ratio}%",
  "contextCompact.failed": "Context compaction failed: {detail}",
  "contextCompact.noHistory": "No history context to compact",
  "contextCompact.originalMessages": "History messages: {count}",
  "contextCompact.source.deterministicFallback": "rule fallback",
  "contextCompact.source.model": "model",
  "contextCompact.summarySource": "Summary source: {source}",
  "contextCompact.toolDigestCount": "Tool result summaries: {count}",
  "contextCompact.unknownError": "Unknown error",
  "detail.label.model": "Model",
  "detail.label.name": "Name",
  "detail.label.role": "Role",
  "detail.noValue": "Not provided",
  "detail.rawMetadata": "Raw metadata",
  "detail.section.members": "Members",
  "detail.section.skills": "Skills",
  "detail.section.tools": "Tools",
  "desktopFileSystem.browserPathPrompt": "Browser restrictions require the project's absolute path",
  "eventPopover.action.collectSnapshot": "Collect event snapshot",
  "eventPopover.action.systemPrompt": "System Prompt",
  "eventPopover.close": "Close event details",
  "eventPopover.copy.all": "Copy all",
  "eventPopover.copy.allShort": "All",
  "eventPopover.copy.arguments": "Copy arguments",
  "eventPopover.copy.awaitingItems": "Copy question/approval/form/plan JSON",
  "eventPopover.copy.collectedSnapshot": "Copy collected snapshot JSON",
  "eventPopover.copy.collectedText": "Copy collected text",
  "eventPopover.copy.currentText": "Copy current text",
  "eventPopover.copy.error": "Copy error message",
  "eventPopover.copy.field": "Copy {field}",
  "eventPopover.copy.menuAria": "Copy menu",
  "eventPopover.copy.message": "Copy message",
  "eventPopover.copy.model": "Copy model",
  "eventPopover.copy.openMenu": "Open copy menu",
  "eventPopover.copy.rawLlmJson": "Copy raw LLM JSON",
  "eventPopover.copy.rawJsonl": "Copy raw JSONL",
  "eventPopover.copy.requestBody": "Copy requestBody",
  "eventPopover.copy.result": "Copy result",
  "eventPopover.copy.sources": "Copy sources JSON",
  "eventPopover.copy.systemPrompt": "Copy systemPrompt",
  "eventPopover.copy.tools": "Copy tools",
  "eventPopover.feedback.copied": "Copied {label}",
  "eventPopover.feedback.copyFailed": "{label} copy failed",
  "eventPopover.group.unknown": "Unknown group",
  "eventPopover.meta.time": "Time: {time}",
  "eventPopover.systemPromptModal.callMetaFallback": "No metadata",
  "eventPopover.systemPromptModal.callTitle": "LLM #{index}",
  "eventPopover.systemPromptModal.calls": "LLM calls",
  "eventPopover.systemPromptModal.close": "Close system prompt",
  "eventPopover.systemPromptModal.empty": "No system prompt text was found for this call.",
  "eventPopover.systemPromptModal.error": "System prompt failed to load: {message}",
  "eventPopover.systemPromptModal.loading": "Loading system prompt...",
  "eventPopover.systemPromptModal.timeout": "Loading system prompt timed out.",
  "eventPopover.systemPromptModal.title": "System Prompt",
  "eventPopover.title.doubleClickCopy": "Double-click to copy all",
  "leftSidebar.awaitingApproval": "Awaiting approval",
  "leftSidebar.awaitingStatus.plan": "Await Impl",
  "leftSidebar.awaitingStatus.question": "Await Ques",
  "leftSidebar.awaitingStatus.approval": "Await Appr",
  "leftSidebar.awaitingStatus.form": "Await Submit",
  "leftSidebar.automationSource": "Created by automation",
  "leftSidebar.browserFolderUnsupported": "Browser folder selection is not supported",
  "leftSidebar.browserWorkspaceOpenUnavailable": "Browser-imported projects do not expose a local workspace folder",
  "leftSidebar.terminalActive": "This agent has a terminal",
  "leftSidebar.terminalBusy": "This agent's terminal is running a command",
  "leftSidebar.importingProject": "Importing project...",
  "leftSidebar.filterChats": "Search conversations...",
  "leftSidebar.filterWorkers": "Filter agents by name / key / teamId...",
  "leftSidebar.historyTitle": "Conversation history",
  "leftSidebar.historyTitleWithWorker": "{workerTypeLabel} history · {displayName}",
  "leftSidebar.latestConversationNoReply": "Latest conversation has no reply",
  "leftSidebar.loading": "Loading...",
  "leftSidebar.markAllRead": "Mark all read",
  "leftSidebar.moreActions": "More actions",
  "leftSidebar.newConversation": "New conversation",
  "leftSidebar.noConversations": "No conversations",
  "leftSidebar.noHistory": "No conversation history",
  "leftSidebar.noPreview": "(no preview)",
  "leftSidebar.noRelatedConversations": "No related conversations",
  "leftSidebar.noWorkers": "No {agentPluralLabel}/{teamPluralLabel}",
  "leftSidebar.openWorkspace": "Open workspace",
  "leftSidebar.openSettingsMenu": "Open settings menu",
  "leftSidebar.projectFolderSelectionCanceled": "Project folder selection canceled",
  "leftSidebar.settings": "Settings",
  "leftSidebar.showMore": "View more ({count} total{unreadSuffix})",
  "leftSidebar.showMoreUnreadSuffix": ", {count} unread",
  "leftSidebar.titleUntitled": "(untitled)",
  "leftSidebar.unread": "Unread",
  "leftSidebar.workspaceUnavailable": "Workspace is unavailable in this environment",
  "leftSidebar.coderWorkspaceLabel": "Workspace",
  "leftSidebar.workerLabel": "Agent",
  "leftSidebar.renameAgent": "Rename",
  "leftSidebar.renameAgentPlaceholder": "Enter new name",
  "leftSidebar.renameAgentSuccess": "Name updated",
  "leftSidebar.editAgent": "Edit agent",
  "leftSidebar.deleteAgent": "Delete agent",
  "leftSidebar.deleteAgentConfirm": "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
  "leftSidebar.createProject.title": "Create Project",
  "leftSidebar.createProject.projectName": "Project Name",
  "leftSidebar.createProject.projectNamePlaceholder": "Enter project name",
  "leftSidebar.createProject.projectDirectory": "Project Directory",
  "leftSidebar.createProject.projectType": "Project Type",
  "leftSidebar.createProject.useAcp": "Use ACP",
  "leftSidebar.createProject.acpProxy": "ACP Proxy",
  "leftSidebar.createProject.noAcpProxy": "No running ACP proxy",
  "leftSidebar.createProject.kbaseVectorStore": "Vector Store",
  "leftSidebar.createProject.kbaseVectorStoreLocal": "Local Vector Store",
  "leftSidebar.createProject.kbaseVectorStoreRemote": "Remote Vector Store",
  "leftSidebar.createProject.cancel": "Cancel",
  "leftSidebar.createProject.create": "Create",
  "leftSidebar.createProject.creating": "Creating...",
  "leftSidebar.createProject.nameRequired": "Please enter a project name.",
  "leftSidebar.createProject.kbaseNotImplemented": "KBASE creation is not yet implemented.",
  "leftSidebar.createProject.acpRequired": "Please select a running ACP proxy or disable ACP.",
  "leftSidebar.createProject.directoryPlaceholder": "Paste or type the project directory path",
  "leftSidebar.createProject.directoryRequired": "Please enter a project directory path.",
  "leftSidebar.createProject.creatingProject": "Creating project...",
  "automation.action.generateDraft": "Generate draft",
  "automation.example.rule": "For example: every weekday at 18:00",
  "automation.example.task": "For example: organize the daily customer report",
  "automation.hint": "Confirm to generate a draft with the current {agentLabel} context. You can still edit it before sending. `Ctrl/Cmd + Enter` confirms quickly.",
  "automation.label.rule": "Automation / rule",
  "automation.label.task": "Task",
  "settings.actions.clearLogs": "Clear logs",
  "settings.actions.refreshAgents": "Refresh agents",
  "settings.actions.refreshTeams": "Refresh teams",
  "settings.asr.backendNotConfigured": "The current voice backend does not have ASR configured",
  "settings.asr.clear": "Clear results",
  "settings.asr.fallbackNotice": "Capabilities fetch failed, falling back to defaults",
  "settings.asr.final": "Final transcript",
  "settings.asr.finalPlaceholder": "Waiting for ASR final text...",
  "settings.asr.hint": "This debug flow only verifies that microphone audio reaches Voice ASR and shows the transcription result. It does not trigger TTS.",
  "settings.asr.interim": "Interim transcript",
  "settings.asr.interimPlaceholder": "Waiting for ASR interim text...",
  "settings.asr.label": "ASR voice debug",
  "settings.asr.start": "Start recording",
  "settings.asr.status.connecting": "Connecting to ASR...",
  "settings.asr.status.failed": "ASR debug failed",
  "settings.asr.status.preparing": "Preparing ASR debug...",
  "settings.asr.status.recording": "Recording and sending audio to Voice ASR...",
  "settings.asr.status.socketOpen": "ASR WebSocket is connected. Waiting for the backend to start the task...",
  "settings.asr.status.stopping": "Submitting audio and waiting for the final recognition result...",
  "settings.asr.stop": "Stop and submit",
  "settings.clientGate.enabled": "Enable local client-side gate filtering",
  "settings.clientGate.field.closeHoldMs": "Close Hold (ms)",
  "settings.clientGate.field.openHoldMs": "Open Hold (ms)",
  "settings.clientGate.field.preRollMs": "Pre-roll (ms)",
  "settings.clientGate.field.rmsThreshold": "RMS Threshold",
  "settings.clientGate.hint.primary": "Higher RMS threshold values are harder to trigger and help filter quieter speech. Open/close holds improve stability, and pre-roll helps avoid clipping the first syllable.",
  "settings.clientGate.hint.secondary": "This configuration only persists for the current page session. ASR debug picks it up immediately, active voice chat updates its local gate immediately, and future ASR sessions continue using it.",
  "settings.clientGate.label": "Frontend voice threshold / client gate",
  "settings.close": "Close",
  "settings.conversationMode.chat": "Chat mode",
  "settings.conversationMode.hint": "Choose whether the sidebar defaults to agent conversations or plain chats. Agent mode is the default.",
  "settings.conversationMode.label": "Conversation mode",
  "settings.conversationMode.worker": "Agent mode",
  "settings.language.enUS": "English",
  "settings.language.hint": "Choose the default UI language. URL lang parameters only override the current page.",
  "settings.language.label": "Language",
  "settings.language.zhCN": "Chinese",
  "settings.shared.errorWithDetail": "Error: {detail}",
  "settings.theme.dark": "Dark",
  "settings.theme.hint": "Switch both the custom UI styling and Ant Design theme, and remember the current preference.",
  "settings.theme.label": "Theme",
  "settings.theme.light": "Light",
  "settings.title": "Settings",
  "settings.token.hint.app": "In app mode the host application manages this automatically through the bridge for both the API bearer token and the Voice WebSocket query access_token.",
  "settings.token.hint.web": "Used for the API bearer token and the Voice WebSocket query access_token. It is only stored locally in this browser.",
  "settings.token.label": "Access token",
  "settings.token.placeholder.app": "Token is managed automatically by the host app",
  "settings.token.placeholder.web": "Enter access token...",
  "settings.token.save": "Save",
  "settings.transport.ariaLabel": "Transport mode",
  "settings.transport.hint.sse": "SSE is currently used for query streaming. Live synchronization is disabled, while regular APIs continue to work over HTTP.",
  "settings.transport.hint.ws": "WebSocket is the current default transport. {wsStatusText}.",
  "settings.transport.hint.wsStreaming": "A streamed response is active. Connection state is currently maintained by WebSocket.",
  "settings.transport.label": "Transport mode",
  "settings.transport.wsStatus.connected": "WebSocket connected",
  "settings.transport.wsStatus.connecting": "WebSocket connecting...",
  "settings.transport.wsStatus.disconnected": "WebSocket disconnected",
  "settings.transport.wsStatus.error": "WebSocket connection error",
  "settings.transport.wsStatus.errorWithDetail": "WebSocket connection error: {detail}",
  "settings.tts.label": "TTS voice debug",
  "settings.tts.send": "Send and play",
  "settings.tts.stop": "Stop playback",
  "settingsMenu.ariaLabel": "Settings menu",
  "settingsMenu.archive": "Archive",
  "settingsMenu.archiveDescription": "View archived chats and archive older conversations in bulk.",
  "settingsMenu.memoryInfo": "Memory info",
  "settingsMenu.memoryInfoDescription": "Inspect the current agent's memory records and full details.",
  "settingsMenu.openSettings": "Open settings...",
  "settingsMenu.registries": "Registry config",
  "settingsMenu.registriesDescription": "Manage registry YAML configs.",
  "settingsMenu.skills": "Skills",
  "settingsMenu.skillsDescription": "Edit skill directories, SKILL.md, references, and scripts.",
  "settingsMenu.reserved.appearance": "Appearance preferences (coming soon)",
  "settingsMenu.reserved.connection": "Connection settings (coming soon)",
  "settingsMenu.reserved.description": "Reserved menu entry for a future update.",
  "settingsMenu.reserved.shortcuts": "Keyboard shortcuts (coming soon)",
  "settingsMenu.section.entry": "Settings",
  "settingsMenu.section.reserved": "Reserved",
  "settingsMenu.status.current": "Current",
  "settingsMenu.summary.theme.darkLabel": "Dark",
  "settingsMenu.summary.theme.darkTitle": "Current UI: dark mode",
  "settingsMenu.summary.theme.lightLabel": "Light",
  "settingsMenu.summary.theme.lightTitle": "Current UI: light mode",
  "settingsMenu.summary.transport.sse": "Current transport: SSE",
  "settingsMenu.summary.transport.ws": "Current transport: WebSocket",
  "settingsMenu.summary.transport.wsConnected": "Current transport: WebSocket (ready)",
  "settingsMenu.summary.transport.wsConnecting": "Current transport: WebSocket (connecting)",
  "settingsMenu.summary.transport.wsError": "Current transport: WebSocket (error: {detail})",
  "settingsMenu.ws.connected": "Current connection state: WebSocket is ready.",
  "settingsMenu.ws.connecting": "Current connection state: WebSocket is connecting.",
  "settingsMenu.ws.default": "Open the full settings dialog to inspect connection and theme details.",
  "settingsMenu.ws.error": "Current connection state: {detail}",
  "memoryInfo.actions.close": "Close",
  "memoryInfo.actions.query": "Query",
  "memoryInfo.actions.refresh": "Refresh",
  "memoryInfo.currentAgent": "Current agentKey: {agentKey}",
  "memoryInfo.detail.rawJson": "Raw JSON",
  "memoryInfo.embedding.disabled": "No embedding",
  "memoryInfo.embedding.enabled": "Embedding available",
  "memoryInfo.empty.noAgent": "Select an agent before opening memory info.",
  "memoryInfo.empty.noRecords": "No memory records match the current filters.",
  "memoryInfo.empty.noSummary": "No summary available",
  "memoryInfo.empty.unselected": "Pick a record from the left to inspect all fields.",
  "memoryInfo.errors.loadDetail": "Failed to load memory detail: {detail}",
  "memoryInfo.errors.loadRecords": "Failed to load memory records: {detail}",
  "memoryInfo.field.agentKey": "agentKey",
  "memoryInfo.field.category": "Category",
  "memoryInfo.field.chatId": "chatId",
  "memoryInfo.field.confidence": "Confidence",
  "memoryInfo.field.createdAt": "Created at",
  "memoryInfo.field.embedding": "Embedding",
  "memoryInfo.field.id": "ID",
  "memoryInfo.field.importance": "Importance",
  "memoryInfo.field.kind": "Kind",
  "memoryInfo.field.refId": "refId",
  "memoryInfo.field.scopeKey": "scopeKey",
  "memoryInfo.field.scopeType": "scopeType",
  "memoryInfo.field.sourceTable": "Source table",
  "memoryInfo.field.sourceType": "sourceType",
  "memoryInfo.field.status": "Status",
  "memoryInfo.field.summary": "Summary",
  "memoryInfo.field.tags": "Tags",
  "memoryInfo.field.updatedAt": "Updated at",
  "memoryInfo.filters.any": "Any",
  "memoryInfo.filters.category": "Category",
  "memoryInfo.filters.categoryPlaceholder": "For example general / bugfix",
  "memoryInfo.filters.keyword": "Keyword",
  "memoryInfo.filters.keywordPlaceholder": "Search title / summary / chatId...",
  "memoryInfo.filters.kind": "Kind",
  "memoryInfo.filters.limit": "Limit",
  "memoryInfo.filters.scopeType": "Scope",
  "memoryInfo.filters.status": "Status",
  "memoryInfo.labels.importanceShort": "Importance {value}",
  "memoryInfo.loading.detail": "Loading memory detail...",
  "memoryInfo.loading.records": "Loading memory records...",
  "memoryInfo.panel.detail": "Record detail",
  "memoryInfo.panel.detailHint": "Inspect all fields, embedding state, and raw JSON for the selected record.",
  "memoryInfo.panel.records": "Memory records",
  "memoryInfo.rawJson": "Raw JSON",
  "memoryInfo.subtitle": "Current agent: {label}",
  "memoryInfo.subtitleEmpty": "No agent is available in the current context.",
  "memoryInfo.tab": "Memory records",
  "memoryInfo.title": "Memory info",
  "memoryPreview.actions.preview": "Preview current input",
  "memoryPreview.context.agentKey": "agentKey",
  "memoryPreview.context.chatId": "chatId",
  "memoryPreview.context.teamId": "teamId",
  "memoryPreview.empty.disabled": "Memory context is disabled for the current agent.",
  "memoryPreview.empty.noChat": "Open a conversation before previewing memory context.",
  "memoryPreview.empty.noDecisions": "No selection decisions were returned.",
  "memoryPreview.empty.noItems": "No memory items were selected for this layer.",
  "memoryPreview.empty.noMessage": "Enter the current question before previewing memory context.",
  "memoryPreview.empty.noPrompt": "No prompt text was produced for this layer.",
  "memoryPreview.empty.noResult": "Run a preview to inspect the injected memory prompt.",
  "memoryPreview.errors.load": "Failed to preview memory context: {detail}",
  "memoryPreview.field.message": "Current message",
  "memoryPreview.field.messagePlaceholder": "Use the current composer input or refine it here for debugging.",
  "memoryPreview.layer.observation": "Observation",
  "memoryPreview.layer.session": "Session",
  "memoryPreview.layer.stable": "Stable",
  "memoryPreview.loading.preview": "Previewing memory context...",
  "memoryPreview.panel.input": "Preview input",
  "memoryPreview.panel.inputHint": "This runs the same memory recall path as a real query, without calling the model.",
  "memoryPreview.panel.prompt": "Prompt preview",
  "memoryPreview.panel.promptHint": "Inspect the memory prompt by layer, plus the selected memory items and decisions.",
  "memoryPreview.section.decisions": "Decisions",
  "memoryPreview.section.selectedMemory": "Selected memory",
  "memoryPreview.summary.chars": "{count} chars",
  "memoryPreview.summary.selection": "{selected} selected / {candidate} candidates",
  "memoryPreview.summary.snapshotId": "Snapshot ID",
  "memoryPreview.summary.stopReason": "Stop reason",
  "memoryPreview.tab": "Preview",
  "memoryPreferences.actions.delete": "Delete",
  "memoryPreferences.actions.new": "New preference",
  "memoryPreferences.actions.save": "Save",
  "memoryPreferences.actions.validate": "Validate",
  "memoryPreferences.currentScope": "Current scope: {label} · {fileName}",
  "memoryPreferences.editable.no": "Read-only",
  "memoryPreferences.editable.yes": "Editable",
  "memoryPreferences.empty.noAgent": "Select an agent before opening preferences.",
  "memoryPreferences.empty.noPreference": "No preferences exist in this scope yet.",
  "memoryPreferences.empty.unselected": "Select a preference from the middle list or create a new one.",
  "memoryPreferences.errors.loadScope": "Failed to load scope detail: {detail}",
  "memoryPreferences.errors.loadScopes": "Failed to load scope summaries: {detail}",
  "memoryPreferences.errors.save": "Failed to save preferences: {detail}",
  "memoryPreferences.errors.validate": "Failed to validate markdown: {detail}",
  "memoryPreferences.field.category": "Category",
  "memoryPreferences.field.confidence": "Confidence",
  "memoryPreferences.field.createdAt": "Created at",
  "memoryPreferences.field.id": "ID",
  "memoryPreferences.field.importance": "Importance",
  "memoryPreferences.field.scopeKey": "scopeKey",
  "memoryPreferences.field.scopeType": "scopeType",
  "memoryPreferences.field.status": "Status",
  "memoryPreferences.field.summary": "Content",
  "memoryPreferences.field.tags": "Tags",
  "memoryPreferences.field.title": "Title",
  "memoryPreferences.field.updatedAt": "Updated at",
  "memoryPreferences.loading.scope": "Loading preferences...",
  "memoryPreferences.meta": "{count} records · {editable}",
  "memoryPreferences.metaEmpty": "Scope metadata is not available yet.",
  "memoryPreferences.markdown.hint": "Markdown mode edits the scope's raw entry format, not a free-form document. If you need multi-line notes, lists, or code blocks, switch to Structured mode and edit the Content field there.",
  "memoryPreferences.markdown.switchToRecords": "Switch to structured mode",
  "memoryPreferences.mode.markdown": "Markdown editor",
  "memoryPreferences.mode.records": "Structured mode",
  "memoryPreferences.newRecord": "New preference",
  "memoryPreferences.notice.unsaved": "There are unsaved changes. Save them before switching scope.",
  "memoryPreferences.notice.validationFailed": "Markdown validation failed. Fix the issues before saving.",
  "memoryPreferences.panel.detail": "Preference detail",
  "memoryPreferences.panel.detailHint": "Inspect scope, status, and raw draft fields for the selected preference.",
  "memoryPreferences.panel.editor": "Preference editor",
  "memoryPreferences.panel.records": "Preference list",
  "memoryPreferences.rawJson": "Raw JSON",
  "memoryPreferences.saveSummary": "Saved: {created} created, {updated} updated, {archived} archived, {unchanged} unchanged.",
  "memoryPreferences.scope.agent": "AGENT",
  "memoryPreferences.scope.global": "GLOBAL",
  "memoryPreferences.scope.team": "TEAM",
  "memoryPreferences.scope.user": "USER",
  "memoryPreferences.tab": "Preferences",
  "memoryPreferences.validation.expectedKeyValue": "This line is not a supported field format. Markdown mode only accepts `- [id] Title` and `key: value`; move multi-line notes, lists, or code blocks into the Content field in Structured mode.",
  "memoryPreferences.validation.error": "Line {line} {field}: {message}",
  "memoryPreferences.validation.field.entry": "entry",
  "memoryPreferences.validation.field.field": "field format",
  "memoryPreferences.validation.field.unknown": "unknown location",
  "memoryPreferences.validation.unknown": "Unknown validation error",
  "memoryPreferences.validation.warning": "Warning line {line} {field}: {message}",
  "mermaid.status.failedWithDetail": "Mermaid chart render failed: {detail}",
  "mermaid.status.parseFailed": "Mermaid syntax parse failed.",
  "mermaid.status.receiving": "Receiving Mermaid chart...",
  "mermaid.status.renderFailed": "Mermaid chart render failed.",
  "mermaid.status.rendering": "Rendering Mermaid chart...",
  "mermaid.status.updating": "Updating...",
  "mermaid.viewport.ariaLabel": "Click to zoom Mermaid chart, drag to pan Mermaid chart",
  "mermaid.viewport.title": "Click to zoom",
  "mermaid.zoom.in": "Zoom in",
  "mermaid.zoom.inAria": "Zoom in Mermaid chart",
  "mermaid.zoom.out": "Zoom out",
  "mermaid.zoom.outAria": "Zoom out Mermaid chart",
  "mermaid.zoom.reset": "Reset",
  "mermaid.zoom.resetAria": "Reset Mermaid chart zoom",
  "planningTimeline.copy": "Copy",
  "planningTimeline.copySuccess": "Copied",
  "planningTimeline.expand": "Expand plan",
  "planningTimeline.implementPlan": "Implementation plan",
  "planningTimeline.openInSidebar": "Open in sidebar",
  "planningTimeline.writing": "Writing plan",
  "route.title.agent": "Agent",
  "route.title.agents": "Agents",
  "route.title.archives": "Archives",
  "route.title.automations": "Automation",
  "route.title.memory": "Memory",
  "route.title.registries": "Registries",
  "route.title.skills": "Skills",
  "skillConsole.action.createFile": "New file",
  "skillConsole.action.createDir": "New directory",
  "skillConsole.action.createSkill": "New skill",
  "skillConsole.action.delete": "Delete",
  "skillConsole.action.download": "Download",
  "skillConsole.action.refresh": "Refresh",
  "skillConsole.action.replaceFile": "Replace file",
  "skillConsole.action.rename": "Rename",
  "skillConsole.action.retry": "Retry",
  "skillConsole.action.save": "Save",
  "skillConsole.action.validate": "Validate",
  "skillConsole.confirm.switchFile": "This file has unsaved changes. Discard them?",
  "skillConsole.confirm.switchSkill": "This skill has unsaved changes. Discard them?",
  "skillConsole.create.description": "Enter a skill key and name. A skill directory with a SKILL.md template will be created.",
  "skillConsole.create.fileNamePlaceholder": "File name (with extension)",
  "skillConsole.create.title": "New skill",
  "skillConsole.delete.confirm": "Are you sure you want to delete skill {name}? This action cannot be undone.",
  "skillConsole.detail.empty": "Select a skill from the list to view details.",
  "skillConsole.diagnostics.empty": "No diagnostics",
  "skillConsole.diagnostics.fileTitle": "File diagnostics",
  "skillConsole.diagnostics.title": "Skill diagnostics",
  "skillConsole.editor.language": "Language",
  "skillConsole.editor.readonly": "Read-only",
  "skillConsole.editor.untitled": "Untitled",
  "skillConsole.empty": "No skills available.",
  "skillConsole.field.fileCount": "Files",
  "skillConsole.field.key": "Key",
  "skillConsole.field.name": "Name",
  "skillConsole.field.path": "Path",
  "skillConsole.field.size": "Size",
  "skillConsole.field.status": "Status",
  "skillConsole.field.updatedAt": "Updated",
  "skillConsole.fileOp.createFile": "Create file",
  "skillConsole.fileOp.createDir": "Create directory",
  "skillConsole.fileOp.delete": "Delete",
  "skillConsole.fileOp.deleteConfirm": "Delete {type} {name}?",
  "skillConsole.fileOp.rename": "Rename",
  "skillConsole.fileTree.empty": "Skill directory is empty",
  "skillConsole.fileTree.root": "Files",
  "skillConsole.list.count": "Skills {count}",
  "skillConsole.message.noMatch": "No matching skills.",
  "skillConsole.message.saveFailed": "Save failed",
  "skillConsole.message.saveSuccess": "Saved successfully",
  "skillConsole.message.unsaved": "Unsaved changes",
  "skillConsole.message.validateInvalid": "{count} issue(s) found",
  "skillConsole.message.validateSuccess": "Validation passed",
  "skillConsole.searchPlaceholder": "Search skills...",
  "skillConsole.statusFilter.all": "All",
  "skillConsole.statusFilter.disabled": "Disabled",
  "skillConsole.statusFilter.invalid": "Invalid",
  "skillConsole.statusFilter.ready": "Ready",
  "skillConsole.status.ready": "Ready",
  "skillConsole.status.invalid": "Invalid",
  "skillConsole.status.disabled": "Disabled",
  "slash.command.debug.description": "Toggle the right-side debug panel or drawer",
  "slash.command.debug.label": "Debug panel",
  "slash.command.detail.description": "Inspect the model, skills, tools, and metadata of the current {agentLabel} or {teamLabel}",
  "slash.command.detail.label": "Current details",
  "slash.command.history.description": "View recent conversations for the current {agentLabel} or {teamLabel}",
  "slash.command.history.label": "Conversation history",
  "slash.command.learn.description": "Extract reusable lessons, rules, and practices from the current conversation and submit them to the learning endpoint",
  "slash.command.learn.label": "Learn from chat",
  "slash.command.compact.description": "Compact older context for this conversation while keeping recent turns and audit history",
  "slash.command.compact.label": "Compact context",
  "slash.command.new.description": "Clear the current conversation context while keeping the current worker selection",
  "slash.command.new.label": "New conversation",
  "slash.command.plan.description": "Toggle planning mode",
  "slash.command.plan.label": "Planning mode",

  "slash.command.remember.description": "Store long-term preferences, facts, or constraints through the memory endpoint",
  "slash.command.remember.label": "Save memory",
  "slash.command.automation.description": "Prefill an automation draft for the current {agentLabel} or {teamLabel}",
  "slash.command.automation.label": "Automation",
  "slash.command.settings.description": "Open the settings dialog",
  "slash.command.settings.label": "Settings",
  "slash.command.switch.description": "Search and switch the current {agentLabel} or {teamLabel}",
  "slash.command.switch.label": "Switch {agentLabel}",
  "slash.command.voice.description": "Switch between text input and turn-based voice chat",
  "slash.command.voice.label": "Voice mode",
  "slash.command.usage.description": "View token usage and cost for the current conversation",
  "slash.command.usage.label": "Usage stats",
  "slashPalette.ariaLabel": "Slash commands",
  "switch.ariaLabel": "Switch {agentLabel}",
  "switch.empty": "No matching {agentLabel} or {teamLabel} found.",
  "switch.preview.noHistory": "No conversation history",
  "switch.scope.all": "All",
  "switch.scopeLabel": "Switch scope",
  "switch.searchPlaceholder": "Search by name / key / role...",
  "switch.workerType.agent": "{agentLabel}",
  "switch.workerType.team": "{teamLabel}",
  "timeline.awaitingAnswer.canceled": "Awaiting canceled",
  "timeline.awaitingAnswer.error": "Awaiting error",
  "timeline.awaitingAnswer.noAnswer": "(No answer content)",
  "timeline.awaitingAnswer.submitFailed": "Submit failed",
  "timeline.awaitingAnswer.submitted": "Answers submitted",
  "timeline.awaitingAnswer.timeout": "Awaiting timed out",
  "timeline.agentSwitcher.ariaLabel": "Switch agent, currently {name}",
  "timeline.agentSwitcher.empty": "No matching agents",
  "timeline.agentSwitcher.listAriaLabel": "Agent list",
  "timeline.agentSwitcher.searchPlaceholder": "Search agents by name / role...",
  "timeline.empty.default": "How can I help today?",
  "timeline.empty.withAgentPrefix": "Chat with ",
  "timeline.empty.withAgentSuffix": "",
  "timeline.empty.withWorker": "Chat with {name}",
  "timeline.source.collapse": "Hide source chunks",
  "timeline.source.expand": "Show source chunks",
  "timeline.source.locator.line": "Line {start}",
  "timeline.source.locator.lineRange": "Lines {start}-{end}",
  "timeline.source.locator.page": "Page {start}",
  "timeline.source.locator.pageRange": "Pages {start}-{end}",
  "timeline.source.locator.slide": "Slide {start}",
  "timeline.source.locator.slideRange": "Slides {start}-{end}",
  "timeline.source.score": "score {score}",
  "timeline.source.title": "Searched {count} sources",
  "timeline.time.today": "Today",
  "timeline.time.yesterday": "Yesterday",
  "timeline.toolPill.copy.action": "Copy",
  "timeline.toolPill.copy.copied": "Copied",
  "timeline.toolPill.copy.failed": "Copy failed",
  "timeline.toolPill.duration.milliseconds": "{count}ms",
  "timeline.toolPill.duration.hours": "{hours}h {minutes}m {seconds}s",
  "timeline.toolPill.duration.minutes": "{minutes}m {seconds}s",
  "timeline.toolPill.duration.seconds": "{count}s",
  "timeline.toolPill.empty": "Empty",
  "timeline.toolPill.groupTitle": "{label}",
  "timeline.toolPill.noOutput": "(No output)",
  "timeline.toolPill.runTitle": "Run {index}",
  "timeline.toolPill.status.canceled": "Canceled",
  "timeline.toolPill.status.completed": "Waiting for result",
  "timeline.toolPill.status.failed": "Failed",
  "timeline.toolPill.status.pending": "Pending",
  "timeline.toolPill.status.running": "Running",
  "timeline.toolPill.status.success": "Done",
  "timeline.toolPill.wrap.disable": "Disable line wrap",
  "timeline.toolPill.wrap.enable": "Line wrap",
  "timeline.responseDuration.hours": "{hours}h {minutes}m",
  "timeline.taskStatus.running": "Running",
  "timeline.taskStatus.completed": "Completed",
  "timeline.taskStatus.failed": "Failed",
  "timeline.taskStatus.canceled": "Canceled",
  "timeline.taskStatus.default": "Task",
  "timeline.thinking.inProgress": "Thinking...",
  "timeline.thinking.title": "Thinking process",
  "timeline.query.noText": "(No text query)",
  "timeline.query.resend": "Resend",
  "timeline.query.resendInNewChat": "Resend in new chat",
  "timeline.run.processed": "Worked for {duration}",
  "timeline.run.responseDuration": "Response took {duration}",
  "timeline.run.deriveChat": "Derive new chat",
  "timeline.run.deriveChatSuccess": "New chat derived",
  "timeline.run.deriveChatFailed": "Failed to derive new chat",
  "timeline.feedback.downvote": "Thumbs down",
  "timeline.feedback.clearDownvote": "Clear downvote",
  "timeline.feedback.downvoted": "Downvoted",
  "timeline.feedback.cleared": "Downvote cleared",
  "timeline.feedback.title": "Feedback (optional)",
  "timeline.feedback.placeholder": "We'd like to know what you were unsatisfied with. What do you think a better answer would be?",
  "timeline.feedback.submit": "Submit",
  "platformError.category.auth": "Sign-in or permission verification failed. Sign in again or contact an administrator.",
  "platformError.category.chat_run": "The run failed. Please try again later.",
  "platformError.category.model": "The model service request failed. Please try again later.",
  "platformError.category.protocol": "The connection protocol failed. Please try again later.",
  "platformError.category.request": "The request is invalid and cannot be processed.",
  "platformError.category.system": "The service hit an internal error. Please try again later.",
  "platformError.category.timeout": "The operation timed out. Please try again later.",
  "platformError.code.active_run_conflict": "This conversation already has a run in progress.",
  "platformError.code.forbidden": "You do not have permission to perform this action.",
  "platformError.code.internal_error": "The service hit an internal error. Please try again later.",
  "platformError.code.invalid_request": "The request is invalid and cannot be processed.",
  "platformError.code.provider_auth_failed": "Model service authentication failed. Contact an administrator to check the API key.",
  "platformError.code.provider_bad_response": "The model service returned an invalid response. Please try again later.",
  "platformError.code.provider_content_filter": "The model service rejected this content. Adjust the input and try again.",
  "platformError.code.provider_context_length_exceeded": "The context is too long for the model. Reduce the input or enable compression.",
  "platformError.code.provider_model_not_found": "The model does not exist in the model service. Switch models or check the configuration.",
  "platformError.code.provider_network_error": "Could not connect to the model service. Please try again later.",
  "platformError.code.provider_permission_denied": "The model service denied permission. Contact an administrator to check the model or account permissions.",
  "platformError.code.provider_quota_exhausted": "The model service quota is exhausted. Switch models or contact an administrator to check the API key or quota.",
  "platformError.code.provider_rate_limited": "The model service is receiving requests too frequently. Please try again later.",
  "platformError.code.provider_request_failed": "The model service request failed.",
  "platformError.code.provider_timeout": "The model service timed out. Please try again later.",
  "platformError.code.provider_unavailable": "The model service is temporarily unavailable. Please try again later.",
  "platformError.code.run_not_found": "The run does not exist or has already ended.",
  "platformError.code.run_timeout": "The run timed out. Please try again later.",
  "platformError.code.service_unavailable": "The service is temporarily unavailable. Please try again later.",
  "platformError.code.stream_failed": "The run stream failed. Please try again later.",
  "platformError.code.too_many_observers": "There are too many observers. Please try again later.",
  "platformError.code.too_many_streams": "There are too many active streams. Please try again later.",
  "platformError.code.unauthorized": "You are not signed in, or your session has expired. Sign in again.",
  "platformError.code.unavailable": "The service is temporarily unavailable. Please try again later.",
  "platformError.detail.category": "Category",
  "platformError.detail.code": "Code",
  "platformError.detail.message": "Original message",
  "platformError.detail.retryable": "Retryable",
  "platformError.detail.scope": "Scope",
  "platformError.detail.status": "Status",
  "platformError.generic": "The operation failed. Please try again later.",
  "platformError.retryableHint": "You can try again later.",
  "platformError.special.channelNotConnected": "The service channel is not connected. Check the backend channel status.",
  "platformError.technicalDetails": "Technical details",
  "topNav.audio.mute": "Mute voice output",
  "topNav.audio.unmute": "Unmute",
  "topNav.debug.close": "Close debug panel",
  "topNav.debug.open": "Open debug panel",
  "topNav.newConversation": "Start new conversation",
  "topNav.newProject": "New Project",
  "topNav.noSelection": "No {agentLabel} selected",
  "topNav.openDrawer": "Open conversation list",
  "topNav.status.error": "error",
  "topNav.status.idle": "idle",
  "topNav.status.running": "running",
  "topNav.terminal.close": "Close terminal panel",
  "topNav.terminal.open": "Open terminal panel",
  "topNav.usage.close": "Close usage stats",
  "topNav.usage.cacheHitRate": "Cache hit",
  "topNav.usage.compact": "Compact",
  "topNav.usage.contextWindow": "Ctx Window",
  "topNav.usage.estimatedNext": "next ctx {value}",
  "topNav.usage.metric.cacheHit": "Cache hit",
  "topNav.usage.metric.cacheMiss": "Cache miss",
  "topNav.usage.metric.completion": "Completion",
  "topNav.usage.metric.firstTokenLatency": "First token",
  "topNav.usage.metric.llmCalls": "LLM calls",
  "topNav.usage.metric.outputTokensPerSecond": "Output speed",
  "topNav.usage.metric.prompt": "Prompt",
  "topNav.usage.metric.reasoning": "Reasoning",
  "topNav.usage.metric.toolCalls": "Tool calls",
  "topNav.usage.metric.total": "Total",
  "topNav.usage.modelUnknown": "Unknown model",
  "topNav.usage.open": "Open usage stats",
  "topNav.usage.section.chat": "Chat total",
  "topNav.usage.section.compact": "Context compaction",
  "topNav.usage.section.current": "Current call",
  "topNav.usage.section.run": "Latest run",
  "topNav.usage.title": "Usage stats",
  "topNav.usage.totalCost": "Total cost",
  "topNav.usage.totalShort": "{total} tokens",
  "topNav.usage.waiting": "Waiting for usage stats...",
  "topNav.usage.waitingShort": "Usage",
  "topNav.voice.hangup": "Hang up voice chat",
  "topNav.voice.hangupWithShortcut": "Hang up voice chat (Esc)",
  "topNav.voice.open": "Open voice chat",
  "topNav.voice.openWithShortcut": "Open voice chat ({shortcut})",
  "voice.chat.error.asrFailure": "ASR failed",
  "voice.chat.error.asrNotConfigured": "The current voice backend has not configured ASR, so voice chat is unavailable.",
  "voice.chat.error.connectionFailed": "Voice WebSocket connection failed",
  "voice.chat.error.invalidVoicesResponse": "The voice backend returned an invalid voice list format",
  "voice.chat.error.linkRecoveryFailed": "Voice link recovery failed: {reason}",
  "voice.chat.error.noSelectedVoice": "The current voice backend did not return an available voice.",
  "voice.chat.error.reconnectStartAsrFailed": "Unable to start ASR after reconnecting the voice WebSocket",
  "voice.chat.error.streamTtsNotEnabled": "The current voice backend has not enabled streaming TTS input, so voice chat is unavailable.",
  "voice.chat.error.taskStopped": "Voice recognition task stopped",
  "voice.chat.error.voiceSocketNotConnected": "Voice WebSocket is not connected yet",
  "agentRoute.loading.agent": "Loading agent",
  "agentRoute.loading.chat": "Loading conversation",
  "leftSidebar.quickActions.agents": "Agents",
  "leftSidebar.quickActions.automation": "Automation",
  "leftSidebar.quickActions.memory": "Memory",
  "voice.debug.defaultTtsText": "This is a TTS debug voice sample. If you can hear it, the current voice playback path is working.",
  "ws.connectionFailedWithMessage": "WebSocket connection failed: {message}",
  "ws.disconnected": "WebSocket disconnected. Please try again later.",
  "ws.handshakeFailed": "WebSocket handshake failed. Check that the access token is valid and that the backend has enabled /ws.",
  "ws.heartbeatTimeout": "WebSocket heartbeat timed out. The connection has reconnected automatically. Retry the current request.",
  "ws.missingAccessToken.browser": "Missing access token. Cannot establish a WebSocket connection. Enter a valid token in Settings first.",
  "ws.missingAccessToken.host": "Missing access token. Cannot establish a WebSocket connection. Confirm the host application has provided a valid token.",
  "ws.transportNotInitialized": "WebSocket transport is not initialized yet. Switch to WebSocket mode and confirm the connection first.",
  "logoLoading.text": "Loading...",
};
